import React from 'react'
import { formatNumber, percentageFormat } from '../../../../../Utils/utils';

interface SecondCardImproveModalityProps {
    selectedModality: any;
}

const SecondCardImproveModality = ({ selectedModality }: SecondCardImproveModalityProps) => {
  return (
          <div className="card-verify">
        <div className="card-verify__rows">
          {selectedModality.respuestaMacro && (
            <div>
              <div className="card-verify__quote">Cesión Comisión</div>
              <div className="card-verify__data">
                {(selectedModality.mejoraParcial &&
                  selectedModality.mejoraParcial.cesionComision) ||
                  "0"}
                %
              </div>
            </div>
          )}
          {selectedModality.respuestaMacro && (
            <div>
              <div className="card-verify__quote">TIR(%)</div>
              <div className="card-verify__data">
                {percentageFormat(selectedModality.respuestaMacro.tir) || '--'}
              </div>
            </div>
          )}
          {selectedModality.respuestaMacro && selectedModality.respuestaMacro.van && (
            <div>
              <div className="card-verify__quote">VAN</div>
              <div className="card-verify__data">
                {selectedModality.respuestaMacro.van || '--'}
              </div>
            </div>
          )}
        </div>
        <div className="card-verify__rows-line"></div>
        {selectedModality.respuestaMacro && (
          <div className="card-verify__rows">
            <div>
              <div className="card-verify__quote">Renta Vitalicia</div>
              <div className="card-verify__data">
                {formatNumber.new(selectedModality.respuestaMacro.primaPensionRv) || '--'}
              </div>
            </div>
            <div>
              <div className="card-verify__quote">Renta Temporal</div>
              <div className="card-verify__data">
                {formatNumber.new(selectedModality.respuestaMacro.primaPensionRt) || '--'}
              </div>
            </div>
          </div>
        )}
      </div>
  )
}

export default SecondCardImproveModality